.contenedor {
  position: relative;
  display: inline-flex;
}

.disparador {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Objetivo táctil cómodo: por debajo de esto se falla el toque. */
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: var(--radius-input);
  background: var(--card);
  color: var(--text-2);
  cursor: pointer;
}

.disparador:hover {
  color: var(--text-1);
  border-color: var(--accent);
}

.disparador:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 2px;
}

.panel {
  display: none;
  position: absolute;
  top: calc(100% + 0.25rem);
  right: 0;
  z-index: 40;
  min-width: 11rem;
  padding: 0.25rem;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-elevado, 0 8px 24px rgb(0 0 0 / 18%));
}

.aIzquierda .panel {
  right: auto;
  left: 0;
}

.panelAbierto {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

/*
 * Las opciones llegan como botones sueltos; aquí se les da forma de fila de
 * menú: ancho completo, alineadas a la izquierda y con el texto visible aunque
 * el botón fuera de sólo icono.
 */
.panel > * {
  width: 100%;
  justify-content: flex-start;
  aspect-ratio: auto;
  padding: 0.45rem 0.6rem;
  border: none;
  background: none;
  box-shadow: none;
}

.panel > *:hover:not(:disabled) {
  background: var(--superficie-elevada);
}

/* Dentro del menú siempre se lee el texto, aunque el botón sea compacto. */
.panel :global(.texto) {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip-path: none;
}

/*
 * En escritorio, cuando se pide `soloEnMovil`, el menú desaparece y las
 * opciones se muestran sueltas en fila: ahí sobra sitio y un clic es mejor que
 * dos.
 */
@media (min-width: 768px) {
  .soloEnMovil .disparador {
    display: none;
  }

  .soloEnMovil .panel {
    display: flex;
    position: static;
    flex-direction: row;
    gap: 0.25rem;
    min-width: 0;
    padding: 0;
    background: none;
    border: none;
    box-shadow: none;
  }

  .soloEnMovil .panel > * {
    width: auto;
  }
}
